module.exports = __webpack_public_path__ + "img/process-settlement.4460b45a.jpg";